import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KeyValue } from '../App/keyvalue.pipe';

declare var jquery: any;
declare var $: any;
type AOA = any[][];

@Component({
    templateUrl: './AppViews/FileUpload/FileUpload.html'
})



export class FileUploadComponent implements OnInit {
    showLoader: boolean = false;
    constants: Constants;
    userDetail: any;
    showUploadBlock: boolean = true;
    showProcessBlock: boolean = false;
    showErrorBlock: boolean = false;
    showSuccessBlock: boolean = false;
    dataInputFileConfig: any = {};
    menuList: any[];
    setProcessTab: any = false;
    setUploadTab: any = false;
    missingDataList: any = [];
    TaskList: any = [];
    dataInputFileTypeId: any;
    dataInputUploadId: any;
    message: any = {};
    TaskId: any = 0;
    ValidCall: any = true;
    uploadedDataList: any[];

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));

    }

    ngOnInit() {
        this.getMenuList();
        this.GetTaskList();
    }

    fileHeads = [
        "Head1", "Head2", "Head3", "Head4", "Head5", "Head6", "Head7"
    ]

    ourHeaders = [
        {
            "name": "OurHead1",
            "mappedField": ""
        },
        {
            "name": "OurHead2",
            "mappedField": ""
        },
        {
            "name": "OurHead3",
            "mappedField": ""
        },
        {
            "name": "OurHead4",
            "mappedField": ""
        },
        {
            "name": "OurHead5",
            "mappedField": ""
        }
    ];
    headerLineNumber = 1;

    GetTaskList() {
        this.showLoader = true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        }
        this._httpService.ajaxPost('DataInput/GetTaskListForDropdown', { "LogginUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.TaskList = data["TaskList"];
            },
            err => { console.log("GetProjectList Failed"); this.showLoader = false; },
            () => { this.showLoader = false; }
        );
    }


    uploadTemplateSelect() {
        var test = $(this).val();
        $("#importVatax tr").removeClass('curSelec');
        $("#importVatax tr").find('input:file').attr('disabled', true);
        $("#importVatax tr").find('.uploadInput').css('display', 'none');
        $("#importVatax tr").find('input:file').val('');
        $("#" + test).parents().closest('tr').addClass('curSelec');
        $("#" + test).parents().closest('tr').find('input:file').removeAttr('disabled');
        $("#" + test).parents().closest('tr').find('.uploadInput').css('display', 'block');
    };

    mapField($event: any, index) {
        if (this.ourHeaders[index].mappedField == "") {
            var s = $event.dragData.pos;
            this.fileHeads.splice(s, 1);
            this.ourHeaders[index].mappedField = $event.dragData.data;
        }
    }

    removeMappedItem(index) {
        this.fileHeads.push(this.ourHeaders[index].mappedField);
        this.ourHeaders[index].mappedField = "";
    }

    fileList = [];
    selectedFileName: any = null;

    onChangeFileInput(event) {
        this.selectedFileName = null;
        this.fileList = [];
        this.fileList = event.target.files;
        var lastThree = this.fileList[0].name.substr(this.fileList[0].name.length - 3);
        var lastFour = this.fileList[0].name.substr(this.fileList[0].name.length - 4);
        if (lastFour.toLowerCase() != 'xlsx' && lastThree.toLowerCase() != 'csv' && lastThree.toLowerCase() != 'xls' && lastFour.toLowerCase() != 'xlsm') {
            $('#salesInvFile').val('');
            this._sharedService.ShowMessage('warning|Please use  .xls, .xlsx, .xlsm, .csv  file');
            return;
        }
        else {
            var file = this.fileList[0];
            this.selectedFileName = file.name;
            //this.uploadDataInputFile();
        }
    }

    clearPreviousMatch() {
        this.fileHeads = [];
        this.ourHeaders.forEach(element => {
            element.mappedField = "";
        });
    }

    public onMenuClick(item,MenuURL) {
        $('.nav-item').removeClass("active");
        setTimeout(function () {
            $("#menuPanelUI" + MenuURL).parent("li").addClass("active");
        }, 0);

        $('#salesInvFile').val('');
        this.selectedFileName = null;
        this.showErrorBlock = false;
        this.showProcessBlock = false;
        this.showUploadBlock = true;
        this.showSuccessBlock = false;
        this.setProcessTab = false;
        this.setUploadTab = false;
        this.missingDataList = [];

        if (item == "Customer Location Upload") {
            this.dataInputFileTypeId = this.constants.dataInputFileTypeId.CustomerLocation;
        }
        else {
            this.dataInputFileTypeId = this.constants.dataInputFileTypeId.TaskLocation;
        }

        this.getDataInputFileConfig();
    }

    getMenuList() {
        this.showLoader = true;
        this._httpService.ajaxPost('login/GetSiteUserMenu', { "siteUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                var menu = data["menuItems"];
                if (menu.length > 0) {
                    var tempParentId = menu.filter(x => x.MenuURL == '/fileUpload')[0].MenuId;
                    if (tempParentId > 0) {
                        this.menuList = menu.filter(x => x.ParentId == tempParentId);
                        this.onMenuClick(this.menuList[0].Name,this.menuList[0].MenuURL);
                    }
                }
                this.showLoader = false;
            }, err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            });
    }


    getDataInputFileConfig() {
        this.showLoader = true;
        this._httpService.ajaxPost("DataInput/GetDataInputUploadInput", { DataInputFileTypeId: this.dataInputFileTypeId, ProfileId: this.userDetail.SiteUserId })
            .subscribe(
                data => {
                    if (data["Status"] && data["ConfigurationList"].length > 0) {
                        this.dataInputFileConfig = data["ConfigurationList"][0];
                        if (data["DataInputFile"].length > 0) {
                            var dataInputFile = data["DataInputFile"][0];

                        }
                        if (data["TemplateFilePath"] != null) {
                            this.dataInputFileConfig.TemplateFilePath = data["TemplateFilePath"];
                        }
                    }
                    this.showLoader = false;
                }, err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                });
    }


    uploadDataInputFile = function () {
        this.ValidCall = true;
        if (this.dataInputFileTypeId == 2) {
            if (this.TaskId == "" ||this.TaskId == null || this.TaskId == 0) {
                this.ValidCall = false;
            }
        }
        if (this.ValidCall) {
            // this.showLoader = true;
            for (let i = 0; i < this.fileList.length; i++) {
                this.UploadFileIndividual(this.fileList[i], this.fileList[i].name, this.fileList[i].type, this.fileList[i].size, i)
            }
        }
        else
        {
            this._sharedService.ShowMessage("error|Please select the task");
        }
    }



    UploadFileIndividual1 = function (fileToUpload, name, type, size, index) {
        this.showLoader = true;
        this._httpService.ajaxPost("DataInput/UploadDataInputFiles", {
            "X-File-Name": name, 'X-File-Type': type, 'X-File-Size': size, 'DataInputFileTypeId': this.dataInputFileTypeId,
            'ProfileId': this.userDetail.SiteUserId
        })
            .subscribe(
                data => {
                    if (data["Status"].Status && data["ConfigurationList"].length > 0) {
                        this.dataInputFileConfig = data["ConfigurationList"][0];
                        if (data["DataInputFile"].length > 0) {
                            var dataInputFile = data["DataInputFile"][0];

                        }
                        if (data["TemplateFilePath"] != null) {
                            this.dataInputFileConfig.TemplateFilePath = data["TemplateFilePath"];
                        }
                    }
                    this.showLoader = false;
                }, err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                });
    }


    UploadFileIndividual = function (fileToUpload, name, type, size, index) {
        // console.log(this.fileList);
        //Create XMLHttpRequest Object
        let reqObj = new XMLHttpRequest();
        //event Handler

        reqObj.upload.addEventListener("progress", uploadProgress, false);
        reqObj.addEventListener("load", uploadComplete.bind(this), false);
        reqObj.addEventListener("error", uploadFailed, false);
        reqObj.addEventListener("abort", uploadCanceled, false);

        //open the object and set method of call(get/post), url to call, isasynchronous(true/False)
        //reqObj.open("POST", "../../Home/UploadFiles", true);
        reqObj.open("POST", this._httpService.apiUrl + "DataInput/UploadDataInputFiles", true);
        //set Content-Type at request header.For file upload it's value must be multipart/form-data
        reqObj.setRequestHeader("enctype", "multipart/form-data");
        // var boundary = '---------------------------';
        // boundary += Math.floor(Math.random()*32768);
        // boundary += Math.floor(Math.random()*32768);
        // boundary += Math.floor(Math.random()*32768);
        // reqObj.setRequestHeader("Content-Type", "multipart/form-data//");
        // reqObj.setRequestHeader("Content-Type", "application/json");


        //Set Other header like file name,size and type
        reqObj.setRequestHeader('X-File-Name', name);
        reqObj.setRequestHeader('X-File-Type', type);
        reqObj.setRequestHeader('X-File-Size', size);
        reqObj.setRequestHeader('DataInputFileTypeId', this.dataInputFileTypeId);
        reqObj.setRequestHeader('ProfileId', this.userDetail.SiteUserId);
        reqObj.setRequestHeader('Access-Control-Allow-Origin', 'AllowAllOrigins');


        let formData = new FormData();
        formData.append("file", fileToUpload, name);
        reqObj.send(formData);
        // send the file
        // reqObj.send(fileToUpload);

        function uploadProgress(evt) {
            if (evt.lengthComputable) {

                let uploadProgressCount = Math.round(evt.loaded * 100 / evt.total);

                document.getElementById('sucess-file').innerHTML = uploadProgressCount.toString();

                if (uploadProgressCount == 100) {
                    document.getElementById('sucess-file').innerHTML =
                        '<i class="fa fa-refresh fa-spin" style="color:maroon;"></i>';
                }

            }
        }

        function uploadComplete(evt) {
            document.getElementById('sucess-file').innerHTML = '';
            let allUploadDone = []
            if (allUploadDone.length > 0) {
            } else {
                $('#file').val();
            }
            var data = JSON.parse(evt.currentTarget.responseText);
            this.message = data["Message"];
            if (data["Message"].Status && this.message.Code != this.constants.messageId.InvalidData && this.message.Code != this.constants.messageId.ColumnMissed) {
                this.showProcessBlock = true;
                this.showErrorBlock = false;
                this.showUploadBlock = false;
                this.uploadedDataList = data["UploadedData"];

            } else {
                if (data["Message"].Status && this.message.Code != this.constants.messageId.Exception) {
                    this.showErrorBlock = true;
                    this.showProcessBlock = false;
                    this.showUploadBlock = false;
                    this.invalidDataList = data["UploadedData"];
                    this.errorFilePath = data["ErrorFilePath"];
                    this.setUploadTab = true;
                } else {
                    this._sharedService.ShowMessage(data["Message"].Text, data["Message"].MessageTypeValue);
                }
            }
            this.dataInputUploadId = data["DataInputUploadId"]
            this.showLoader = false;
        }

        function uploadFailed(evt) {
            document.getElementById('error-file').innerHTML = '<p style="background-color: #f86c6b;color: #fff;padding: .5rem .75rem;font-size: .875rem;"><i class="fa fa-times"></i> Upload Failed..</p>';
        }

        function uploadCanceled(evt) {
            document.getElementById('error-file').innerHTML = '<p style="background-color: #f86c6b;color: #fff;padding: .5rem .75rem;font-size: .875rem;"><i class="fa fa-times"></i> Canceled....</p>';
        }

    }


    processDataInputFile() {
        this.showLoader = true;
        this._httpService.ajaxPost("DataInput/ProcessUploadedData", { DataInputFileTypeId: this.dataInputFileTypeId, ProfileId: this.userDetail.SiteUserId, DataInputUploadId: this.dataInputUploadId, TaskId: this.TaskId }).subscribe(
            data => {
                if (data["Status"].Status && data["Status"].Code == this.constants.messageId.Success) {
                    this.showSuccessBlock = true;
                    this.showErrorBlock = false;
                    this.showUploadBlock = false;
                    this.showProcessBlock = false;
                }
                else {
                    if (data["Status"].Code != this.constants.messageId.Exception) {
                        this.message = data["Status"];
                        this.showSuccessBlock = false;
                        this.showErrorBlock = true;
                        this.showUploadBlock = false;
                        this.showProcessBlock = false;
                        var MissingData = data["MissingData"];
                        if (MissingData != null)
                        {
                        this.missingDataList = MissingData;
                        }
                        else
                        {
                            this.missingDataList = [];
                        }
                        this.setProcessTab = true;
                    } else {

                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                }
                this.showLoader = false;
            },
            (error: any) => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            }
        );
    }

    cancelUploadFile() {
        $('#salesInvFile').val('');
        this.selectedFileName = null;
        this.showErrorBlock = false;
        this.showProcessBlock = false;
        this.showUploadBlock = true;
        this.showSuccessBlock = false;
        this.setProcessTab = false;
        this.setUploadTab = false;
        if (this.message.Code == this.constants.messageId.InvalidData || this.message.Code == this.constants.messageId.Success
            || this.message.Code == this.constants.messageId.DataMissing || this.message.Code == this.constants.messageId.Mandatory)
            this.addUpdateUploadFile();
    }

    viewUploadedData() {
        $('#viewInvalidData').modal('show');
    }


    addUpdateUploadFile() {
        this.showLoader = true;
        this._httpService.ajaxPost("DataInput/AddUpdateUploadFile", { DataInputUploadId: this.dataInputUploadId, StatusId: this.constants.uploadStatus.UploadCancelled })
            .subscribe(
                data => {
                    if (data["Status"].Status) {
                        this.showProcessBlock = false;
                        this.showErrorBlock = false;
                        this.message = {};
                    }
                    this.showLoader = false;
                }, err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                });
    }


    uploadAnotherFile() {
        $('#salesInvFile').val('');
        this.selectedFileName = null;
        this.showSuccessBlock = false;
        this.showErrorBlock = false;
        this.showUploadBlock = true;
        this.showProcessBlock = false;
        this.setProcessTab = false;
        this.setUploadTab = false;
    }


}



/** WEBPACK FOOTER **
 ** ./TypeScripts/FileUpload/FileUpload.component.ts
 **/